import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

import AutocompleteCategories from './AutocompleteCategories';
import AutocompleteProducts from './Products/AutocompleteProducts';
import { Acp } from 'types/Acp';

import styles from './Autocomplete.module.scss';

export const CloseTypes = {
  REDIRECT_PRODUCT: 'productRedirection',
  REDIRECT_CATEGORY: 'categoryRedirection',
  TRIGGER_SEARCH: 'triggerSearch',
} as const;

export type CloseTypesKeys = typeof CloseTypes[keyof typeof CloseTypes];

type Props = {
  data?: Acp;
  onClose?: (type?: CloseTypesKeys) => void;
  onClickSeeAll: (e: React.MouseEvent) => void;
  placementId: string;
};

let preventScrollCount = 0;

export default function Autocomplete({
  data,
  onClose,
  onClickSeeAll,
  placementId,
}: Props): JSX.Element {
  useEffect(() => {
    preventScrollCount += 1;
    if (preventScrollCount === 1) {
      document.body.classList.add(styles.bodyAutoCompletionOpen);
    }

    return () => {
      preventScrollCount -= 1;
      if (preventScrollCount === 0) {
        document.body.classList.remove(styles.bodyAutoCompletionOpen);
      }
    };
  }, []);

  return createPortal(
    <>
      <div className={styles.autocomplete}>
        {data?.pages && (
          <AutocompleteCategories
            categories={data.pages}
            onClick={() => onClose?.(CloseTypes.REDIRECT_CATEGORY)}
          />
        )}
        {data?.products && (
          <AutocompleteProducts
            products={data.products}
            onClickSeeAll={onClickSeeAll}
            onClick={() => onClose?.(CloseTypes.REDIRECT_PRODUCT)}
          />
        )}
      </div>
      <div className={styles.autocompleteOverlay} onClick={() => onClose?.()} />
    </>,
    document.getElementById(placementId) || document.body
  );
}
